<template>
  <div>
    <address-form v-if="!loading" :token="dadataToken" v-model="editedItem.address"
      @update:modelValue="addressChanged" :debounceMs="400"/>
    <v-skeleton-loader v-else type="card"></v-skeleton-loader>
  </div>
</template>

<script>
import suggestion from "moodleDir/procollege/lib/vue/address/suggestion.js";
import addressForm from "moodleDir/procollege/lib/vue/address/form.vue";

let cachedDadataToken = null;
let cachedDadataTokenPromise = null;

function loadDadataToken(axios, wwwroot) {
  if (cachedDadataToken) {
    return Promise.resolve(cachedDadataToken);
  }
  if (cachedDadataTokenPromise) {
    return cachedDadataTokenPromise;
  }
  cachedDadataTokenPromise = axios
    .post(`${wwwroot}/procollege/core_procollege/helpers/Address/getDadataToken`)
    .then((response) => {
      cachedDadataToken = response.data;
      cachedDadataTokenPromise = null;
      return cachedDadataToken;
    })
    .catch((error) => {
      cachedDadataTokenPromise = null;
      throw error;
    });
  return cachedDadataTokenPromise;
}

export default {
  emits: ["update:addressId"],
  components: { addressForm },
  props: {
    addressId: null,
  },

  data() {
    return {
      dadataToken: "",
      editedItem: {
        id: 0,
        address: suggestion,
      },
      loading: true,
    };
  },
  async created() {
    await Promise.all([
      this.fetchData(),
      this.getAddress()
    ]);
   this.loading = false;
  },

  methods: {
    addressChanged() {
      /**
       * TODO распарсить на бэке editedItem.address(что-то в духе Address::findInDB+Address::insert,надо потестить с ручным вводом и выбором подсказки), при необходимости обновить id адреса у студента
       * //this.$emit("update:addressId", newId);
       */
    },
    async fetchData() {
      return loadDadataToken(this.axios, this.$model.wwwroot)
        .then((token) => {
          this.dadataToken = token;
        });
    },
    async getAddress() {
      let standard_address = "";
      if (this.addressId) {
        await this.axios
          .post(
            this.$model.wwwroot +
            "/procollege/core_procollege/helpers/Address/getStandardAddress",
            new URLSearchParams({
              id: this.addressId,
            })
          )
          .then((resp) => {
            standard_address = resp.data;
          }) .catch((error) => {
          console.error("Ошибка загрузки:", error);
          
        });

        await this.axios
          .post(
            this.$model.wwwroot +
            "/procollege/core_procollege/helpers/Address/get",
            new URLSearchParams({
              id: this.addressId,
            })
          )
          .then((resp) => {
            this.editedItem = {
              id: this.addressId,
              address: { value: standard_address, data: resp.data },
            };
          });
      }
    },
  },
};
</script>